import {
  faBatteryEmpty,
  faBatteryHalf,
  faCaretDown,
  faCaretRight,
  faCertificate,
  faCheck,
  faClock,
  faHourglassEnd,
  faRetweet,
  faThumbsDown,
  faTimesCircle,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Tooltip from 'rc-tooltip'
import React, { useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { setShowSubmissionDataManagerReport } from 'store/EmployeeReport/actions'
import { getLabelText, getStatusColorReport } from 'utils/helpers'

export const getFontawesomeIconFromStatus = (status, courseConfig) => {
  // eslint-disable-next-line default-case
  switch (status) {
    case 0:
      return (
        <FontAwesomeIcon
          style={{
            color: getStatusColorReport(status, null, courseConfig),
            fontSize: '14px',
            marginRight: '5px',
          }}
          icon={faBatteryEmpty}
        />
      )
    case 1:
      return (
        <FontAwesomeIcon
          style={{
            color: getStatusColorReport(status, null, courseConfig),
            fontSize: '14px',
            marginRight: '5px',
          }}
          icon={faBatteryHalf}
        />
      )
    case 2:
      return (
        <FontAwesomeIcon
          style={{
            color: getStatusColorReport(status, null, courseConfig),
            fontSize: '14px',
            marginRight: '5px',
          }}
          icon={faThumbsDown}
        />
      )
    case 3:
      return (
        <FontAwesomeIcon
          style={{
            color: getStatusColorReport(status, null, courseConfig),
            fontSize: '14px',
            marginRight: '5px',
          }}
          icon={faCheck}
        />
      )
    case 4:
      return (
        <FontAwesomeIcon
          style={{
            color: getStatusColorReport(status, null, courseConfig),
            fontSize: '14px',
            marginRight: '5px',
          }}
          icon={faCertificate}
        />
      )

    case 6:
      return (
        <FontAwesomeIcon
          style={{
            color: getStatusColorReport(status, null, courseConfig),
            fontSize: '14px',
            marginRight: '5px',
          }}
          icon={faClock}
        />
      )
  }
}

const getLabelTextTooltip = (status) => {
  switch (status) {
    case 0:
      return 'Not started'
    case 1:
      return 'In progress'
    case 3:
      return 'Validation'
    default:
      break
  }
}

export const FirstCellRenderer = (params) => {
  function isHierarchyEnabled() {
    return (
      params.data.moduleParent === 'Corporate' &&
      params.api.frameworkComponentWrapper?.parent?.parent?.props
        .corporateHierarchy === 1
    )
  }
  const link = isHierarchyEnabled()
    ? `/manager-reports`
    : `/manager-reports/employee/${params.data.moduleId}`

  const icon = useMemo(() => {
    return params.data.module === 'location' ? (
      <FontAwesomeIcon
        style={{ fontSize: '16px', marginRight: '5px' }}
        icon={params.data.isActive ? faCaretDown : faCaretRight}
      />
    ) : null
  }, [params.data.module, params.data.isActive])
  return params.data.module === 'location' ? (
    <div
      className={`first-cell icon-container ${
        params.data.module === 'location' ? 'location-pointer' : ''
      }`}
      style={{ cursor: 'pointer' }}
      onClick={() => {
        params.context.handleLocationClick(params.data.moduleName)
      }}
    >
      {icon}
      <span
        style={{
          fontSize: '14px',
          marginLeft: '0',
          fontWeight: '700',
          display: 'inline',
          marginTop: '0',
        }}
      >
        {params.data.moduleSubName ? params.data.moduleSubName : params.value}
        {params.data.jobTitles && (
          <span
            style={{ marginTop: '-3px', display: 'block', fontSize: '10px' }}
          >
            {params.data.jobTitles}
          </span>
        )}
      </span>
    </div>
  ) : (
    <Link to={link} style={{ color: '#8889AA' }}>
      <div
        className={`first-cell icon-container ${
          params.data.module === 'location' ? 'location-pointer' : ''
        }`}
        onClick={() => params.handleLocationClick(params.data.moduleName)}
      >
        {icon}
        <span
          className='d-flex flex-column'
          style={{
            fontSize: '14px',
            marginLeft: '15px',
            fontWeight: 'normal',
            display: 'inline-block',
            marginTop: '-5px',
          }}
        >
          {params.data.moduleSubName ? params.data.moduleSubName : params.value}
          {params.data.jobTitles && (
            <span
              style={{
                display: 'block',
                fontSize: '10px',
                marginTop: params.value.length > 1 ? '-35px' : 'unset',
              }}
            >
              {params.data.jobTitles}
            </span>
          )}
        </span>
      </div>
    </Link>
  )
}

export const OverallCellRenderer = (params) => {
  const completed = '#db9c05'
  return (
    <div className='icon-container'>
      <span>
        <FontAwesomeIcon
          style={{ color: completed, fontSize: '14px', marginRight: '5px' }}
          icon={faCertificate}
        />
      </span>
      <span style={{ color: completed, fontSize: '14px' }}>
        {params.value && params.value.name !== null ? params.value.name : '0 %'}
      </span>
    </div>
  )
}

export const CoreCellRenderer = (params) => {
  const completed = '#db9c05'
  return (
    <div className='icon-container'>
      <span>
        <FontAwesomeIcon
          style={{ color: completed, fontSize: '14px', marginRight: '5px' }}
          icon={faCertificate}
        />
      </span>
      <span style={{ color: completed, fontSize: '14px' }}>
        {params.value.name !== null ? params.value.name : '0 %'}
      </span>
    </div>
  )
}

export const MainCellRenderer = (params) => {
  const dispatch = useDispatch()
  const courseConfig = useSelector((store) => store.courseConfig)
  if (!params.value) {
    return null
  }
  const reassigned = `${
    params.value && params.value.name === 'Reassigned' ? ' reassigned' : ''
  }`
  const expired = `${
    params.value && params.value.name === 'Expired' ? ' expired' : ''
  }`

  const hasPassedQuiz =
    params.value &&
    params.value.status === 4 &&
    params.value.quizPassedPercentage
      ? Math.round(params.value.quizPassedPercentage) + '%'
      : ''

  const hasFailedQuiz =
    params.value &&
    params.value.status === 2 &&
    params.value.quizPassedPercentage
      ? Math.round(params.value.quizPassedPercentage) + '%'
      : ''

  const checklistUrl =
    (params.value && params.value.courseId && params.value.status === 3) ||
    params.value.waiting_for_approval
      ? `/manager-report/${params.data.moduleId}/checklist?course_id=${params.value.courseId}&referred_from_manager_report=true`
      : (params.value &&
          params.value.requireChecklist &&
          params.value &&
          params.value.group_id &&
          params.value &&
          params.value.status === 3) ||
        (params.value && params.value.requireChecklistCompletion)
      ? `/manager-report/${params.data.moduleId}/checklist?group_id=${params.value.group_id}&referred_from_manager_report=true`
      : null

  // const { courseConfig } = params.agGridReact.props.mainProps;

  // const { data: language } =
  //   params.agGridReact.props.mainProps.language.systemDefaultLanguage;

  const language = {}
  return (
    <>
      <div>
        {params.value &&
        params.value.status !== NaN &&
        params.value.name !== 'Past due' ? (
          params.value.name === 'Reassigned' ||
          params.value.name === 'Expired' ||
          params.value.checklistStatus === -1 ? (
            <Tooltip
              placement='top'
              mouseEnterDelay={0.1}
              mouseLeaveDelay={0}
              trigger={['click', 'hover']}
              overlay={
                <span>
                  {getLabelTextTooltip(params.value.status, language.general)}
                </span>
              }
            >
              {params.value.checklistStatus === -1 && (
                <span style={{ marginRight: '10px' }}>
                  {getFontawesomeIconFromStatus(
                    params.value.status,
                    courseConfig
                  )}
                </span>
              )}
            </Tooltip>
          ) : (
            getFontawesomeIconFromStatus(params.value.status, courseConfig)
          )
        ) : null}
        {params.value.isChecklistButton && (
          <Link
            to={`/manager-report/${params.data.moduleId}/checklist?group_id=156&referred_from_manager_report=true`}
          >
            <button className='btn btn-info p-2'>Checklist</button>
          </Link>
        )}
        {params.value && params.value.name === 'Reassigned' ? (
          <FontAwesomeIcon
            style={{ fontSize: '14px', marginRight: '5px' }}
            icon={faRetweet}
            className=' reassigned'
          />
        ) : params.value && params.value.name === 'Expired' ? (
          <FontAwesomeIcon
            style={{ fontSize: '14px', marginRight: '5px' }}
            icon={faHourglassEnd}
            className=' expired'
          />
        ) : params.value &&
          params.value.checklistStatus &&
          params.value.checklistStatus === -1 ? (
          <FontAwesomeIcon
            style={{ fontSize: '14px', marginRight: '5px' }}
            icon={faTimesCircle}
            className=' expired'
          />
        ) : null}
        {params.value && params.value.equivalent ? (
          <Tooltip
            placement='top'
            mouseEnterDelay={0.1}
            mouseLeaveDelay={0}
            trigger={['click', 'hover']}
            overlay={
              <span>{params.value.equivalent ? 'Equivalent to' : ''}</span>
            }
          >
            <span
              style={{
                color: getStatusColorReport(
                  params.value.status,
                  null,
                  courseConfig
                ),
                fontSize: '14px',
                marginRight: '5px',
              }}
            >
              {getLabelText(params.value.name, language)}
            </span>
          </Tooltip>
        ) : params.value && params.value.status === 3 ? (
          <span
            className={'default-class' + reassigned + expired}
            style={{
              color: params.value
                ? getStatusColorReport(params.value.status, null, courseConfig)
                : '',
              fontSize: '14px',
              marginRight: '5px',
            }}
            // className='practice-at-station-link'
          >
            {checklistUrl ? (
              <Link
                to={checklistUrl}
                style={{
                  color:
                    params.value.checklistStatus &&
                    params.value.checklistStatus === -1
                      ? 'red'
                      : courseConfig.validation,
                }}
              >
                {getLabelText(params.value.name, language)}
              </Link>
            ) : (
              <span>{getLabelText(params.value.name, language)}</span>
            )}
          </span>
        ) : params.value && params.value.status === 6 ? (
          <span
            className={'default-class' + reassigned + expired}
            style={{
              color: params.value
                ? getStatusColorReport(params.value.status, null, courseConfig)
                : '',
              fontSize: '14px',
              marginRight: '5px',
            }}
            // className='practice-at-station-link'
          >
            <Link
              onClick={() =>
                dispatch(
                  setShowSubmissionDataManagerReport(
                    params.value.courseId,
                    params.data.moduleId
                  )
                )
              }
            >
              {getLabelText(params.value.name, language)}
            </Link>
          </span>
        ) : (
          <span
            className={'default-class' + reassigned + expired}
            style={{
              color: params.value
                ? getStatusColorReport(params.value.status, null, courseConfig)
                : '',
              fontSize: '14px',
              marginRight: '5px',
            }}
          >
            {checklistUrl ? (
              <Link
                to={checklistUrl}
                style={{ color: courseConfig.validation }}
              >
                {getLabelText(params.value.name, language)}
              </Link>
            ) : (
              <React.Fragment>
                <span>
                  {hasPassedQuiz
                    ? getLabelText(
                        params.value && params.value.name,
                        language
                      ) + ` Quiz:${hasPassedQuiz}`
                    : hasFailedQuiz
                    ? getLabelText(
                        params.value && params.value.name,
                        language
                      ) + ` Quiz:${hasFailedQuiz}`
                    : getLabelText(params.value && params.value.name, language)}
                </span>
                {params.value.name === 'Certified' &&
                params.value.isExternalReport ? (
                  <span>{': ' + params.value.date}</span>
                ) : (
                  ''
                )}
              </React.Fragment>
            )}
          </span>
        )}
      </div>
    </>
  )
}
